
        <input-dropdown [classNames]="classNames" [disabled]="culturesLoading" [items]="filteredLanguages" valuePath="name" itemTitlePath="nativeName" [value]="language"
            (valueChange)="currentLanguageChanged($event)"></input-dropdown>
    